class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.cartTimer = this.querySelector("cart-timer");

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this),
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    if (this.cartTimer) this.cartTimer.initTimer();
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    if (this.cartTimer) this.cartTimer.initTimer();
    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id,
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this),
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  productAddedToCart() {
    if (this.cartTimer) this.cartTimer.productAddedToCart();
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

class CartTimer extends HTMLElement {
  constructor() {
    super();

    this.currentInterval = null;
    this.cartCountdowns = document.querySelectorAll(".cartCountdown");
    this.initTimer();
  }

  getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }

  setWithExpiry(key, value) {
    const now = new Date();
    const ttl = 60 * 60 * 24;

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  setCountdown(value) {
    this.cartCountdowns.forEach((elem) => (elem.textContent = value));
  }

  hideAlerts() {
    document
      .querySelectorAll(".cartCountdownAlert")
      .forEach((elem) => elem.classList.add("hideAlert"));
  }

  startTimer(duration, display) {
    var timer = duration,
      minutes,
      seconds;
    this.currentInterval = setInterval(() => {
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);

      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      this.setCountdown(`${minutes}:${seconds}`);
      this.setWithExpiry("cartTimer", timer);
      if (--timer < 0) {
        this.hideAlerts();
        clearInterval(this.currentInterval);
        this.currentInterval = null;
      }
    }, 1000);
  }

  connectedCallback() {
    this.initTimer();
  }

  initTimer() {
    var currentValue = parseInt(this.getWithExpiry("cartTimer"));

    if (!this.currentInterval && currentValue > 0) {
      var minutes = parseInt(currentValue / 60, 10);
      var seconds = parseInt(currentValue % 60, 10);

      minutes = minutes < 10 ? `0${minutes}` : minutes;
      seconds = seconds < 10 ? `0${seconds}` : seconds;

      this.setCountdown(`${minutes}:${seconds}`);
      this.startTimer(currentValue - 1, this.cartCountdown);

      document
        .querySelectorAll(".cartCountdownAlert")
        .forEach((elem) => elem.classList.remove("hideAlert"));
    }
    if (currentValue == 0) {
      this.hideAlerts();
    }
  }

  productAddedToCart() {
    var tenMinutes = 60 * 10;
    if (this.currentInterval) {
      clearInterval(this.currentInterval);
      this.currentInterval = null;
    }
    var minutes = parseInt(tenMinutes / 60, 10);
    var seconds = parseInt(tenMinutes % 60, 10);

    minutes = minutes < 10 ? `0${minutes}` : minutes;
    seconds = seconds < 10 ? `0${seconds}` : seconds;

    this.setCountdown(`${minutes}:${seconds}`);
    document
      .querySelectorAll(".cartCountdownAlert")
      .forEach((elem) => elem.classList.remove("hideAlert"));
    this.setWithExpiry("cartTimer", tenMinutes - 1);
    this.startTimer(tenMinutes - 1, this.cartCountdown);
  }

  cartCleared() {
    this.hideAlerts();
    if (this.currentInterval) {
      clearInterval(this.currentInterval);
      this.currentInterval = null;
    }
    this.setWithExpiry("cartTimer", 0);
  }
}

customElements.define("cart-timer", CartTimer);

class CartDrawerUpsell extends HTMLElement {
  constructor() {
    super();
    this.addButton = this.querySelector("#upsell-add-button");
    this.upsellSelect = this.querySelector("#upsell-select");
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.addButton.addEventListener("click", this.addToCart.bind(this));
  }

  addToCart() {
    console.log(this.upsellSelect.value);

    this.addButton.setAttribute("aria-disabled", true);
    this.addButton.classList.add("loading");
    this.querySelector(".loading__spinner").classList.remove("hidden");

    const config = fetchConfig("javascript");

    const items = JSON.stringify({
      items: [
        {
          id: this.upsellSelect.value,
          quantity: 1,
        },
      ],
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    config.body = items;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: this.upsellSelect.value,
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);

          const soldOutMessage =
            this.submitButton.querySelector(".sold-out-message");
          if (!soldOutMessage) return;
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.querySelector("span").classList.add("hidden");
          soldOutMessage.classList.remove("hidden");
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: this.upsellSelect.value,
            cartData: response,
          });
        this.error = false;
        const quickAddModal = this.closest("quick-add-modal");
        if (quickAddModal) {
          document.body.addEventListener(
            "modalClosed",
            () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            },
            { once: true },
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
          if (this.cart.productAddedToCart) this.cart.productAddedToCart();
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.addButton.classList.remove("loading");
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
        if (!this.error) this.addButton.removeAttribute("aria-disabled");
        this.querySelector(".loading__spinner").classList.add("hidden");
      });
  }
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);

class CartDiscount extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.submit = this.querySelector("button");
    this.submit.addEventListener("click", this.addVoucher.bind(this));
    this.cart = document.querySelector("cart-drawer");
  }

  addVoucher() {
    fetch(`/discount/${this.input.value}`).then(async (res) => {
      console.log(res);
      // update cart
      const response = await fetch(
        `/?sections_url=${window.location.pathname}&sections=${this.cart.getSectionsToRender().map((section) => section.id)}`,
      ).then((response) => response.json());
      const newCart = new DOMParser()
        .parseFromString(response["cart-drawer"], "text/html")
        .querySelector("cart-drawer");

      if (!newCart.classList.contains("cart-discount-added")) {
        this.querySelector("#cart-drawer--discount--error").style.display =
          "block";
      } else {
        this.cart.renderContents({ sections: response });
      }
      // error handling if manual discount is not applied
    });
    console.log();
  }
}
customElements.define("cart-discount", CartDiscount);
